import React from 'react';
import './Contacts.css'
import ContactItem from './ContactItem.js'
import { Button } from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css';

const Contacts = (props) => {

    return (
        <div className="contacts">
            <div className="contact-title">
                Contacts
                <Button className="ui icon circular grey button" onClick={()=>props.setPopUp(true)}>
                    <i className="add icon"></i>
                </Button>
            </div> 
            <div className="contact-list">
                {props.contactList.map(contact => {
                    return <ContactItem key={contact.name} setShowContact={props.setShowContact} number={contact.number} name={contact.name} selectedContact={props.selectedContact} setSelectedContact={props.setSelectedContact} />
                })}
            </div>
        </div>
    );
}

export default Contacts